module.exports = __webpack_public_path__ + "static/img/91012D_1_R_2020821_LC.a147ef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/91012D_1_R_2020821_LC.png
// module id = cU82
// module chunks = 0